import {Component, Input, OnInit} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {UserService} from '@services/user.service';
import {MatDialog} from '@angular/material';
import {AddCardComponent} from '../add-card/add-card.component';
import {FormGroup} from '@angular/forms';
import {LoadUserCards} from '@store/actions/profile.action';
import {AppState, selectUserCards} from '@store/reducers';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-consignment-settings',
  templateUrl: './consignment-settings.component.html',
  styleUrls: ['./consignment-settings.component.scss']
})

export class ConsignmentSettingsComponent {
  @Input() consignmentSettingsForm: FormGroup;

  constructor(
    public faService: FontAwesomeService,
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/consignment-settings/consignment-settings.component.ts